import { RadioButton } from "primereact/radiobutton";
import React from "react";
import RadioCardOptionWrapper from "./style";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

const RadioCardOption = (props) => {
  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  return (
    <RadioCardOptionWrapper
      businessColor={businessColor}
      onClick={() => props.selectOption()}
      className={`field-radiobutton ${props.type || "normal"} ${props.classNames} ${
        props.isChecked ? " active" : ""
      }`}
    >
      <RadioButton
        onChange={props.onChange}
        name={props.name}
        value={props.value}
        checked={props.isChecked}
      />
      <div>
        {props.showIcon && props.icon}
        <label className={`${props.showIcon ? "mx-4" : ""} ${props.small ? "small" : ""}`}>
          {props.label}
        </label>
      </div>
    </RadioCardOptionWrapper>
  );
};

export default RadioCardOption;
